var _path, _rect, _rect2, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1001,
    height: 1001,
    viewBox: "0 0 1001 1001",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.426 932.274C314.186 930.14 317.924 926.231 319.843 921.381L584.415 252.616C587.007 246.065 594.419 242.855 600.971 245.447V245.447C607.522 248.039 610.732 255.451 608.14 262.002L338.773 942.888L337.912 945.505C337.793 945.865 337.645 946.215 337.469 946.551L337.378 946.724C337.218 947.027 337.028 947.313 336.81 947.577L336.565 947.872C336.478 947.978 336.378 948.073 336.268 948.156V948.156C336.165 948.233 336.054 948.298 335.937 948.35L280.719 973.102C274.29 975.984 266.742 973.108 263.86 966.679V966.679C260.978 960.25 263.854 952.701 270.283 949.82L309.426 932.274Z",
    fill: "#FF007A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 613.82,
    y: 157.434,
    width: 40.0716,
    height: 104.802,
    rx: 5,
    transform: "rotate(21.4285 613.82 157.434)",
    fill: "#9D004B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 301.046,
    y: 929.403,
    width: 40.0716,
    height: 104.802,
    rx: 5,
    transform: "rotate(71.676 301.046 929.403)",
    fill: "#9D004B"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 500.565,
    cy: 500.392,
    rx: 29.3249,
    ry: 29.283,
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStick);
export default __webpack_public_path__ + "static/media/stick.acbb4a6af56fa0641d101ebf8f9bdaf5.svg";
export { ForwardRef as ReactComponent };